module.exports = __webpack_public_path__ + "img/ness-min.5227ace4.png";